import SvgIcon from '@mui/material/SvgIcon';
import * as React from 'react';
const SvgBizmachine = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("mask", null, /*#__PURE__*/ React.createElement("path", {
        fill: "url(#bizmachine_svg__a)",
        d: "M3 3v18l9-9z"
    })), /*#__PURE__*/ React.createElement("g", null, /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        fillOpacity: 0.54,
        d: "M3 3v18l9-9z"
    })), /*#__PURE__*/ React.createElement("path", {
        d: "M21 3v18H3z"
    }), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "bizmachine_svg__a",
        x1: 3,
        x2: 12,
        y1: 3,
        y2: 12,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", null), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopOpacity: 0.5
    }))));
export default SvgBizmachine;
